/**
 * Sign in snippet
 *
 * @author Mautilus s.r.o.
 * @class Snippet_SignIn
 * @extends Snippet
 */

Snippet_SignIn = (function(Snippet) {

	var Snippet_SignIn = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_SignIn.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(parent, config){
			this.$lastFocused = null;

			this.$snippetEl = this.$el.find('#snippet-signin');
			this.errorField = [];
            this.varTimeout;
			var userName = Storage.get('userName');
		},

		/**
		 * prepare relevant divs for inputs and keyboard
		 *
		 * @private
		 *
		 * @param {Object} jQuery element where should be input
		 * @param {String} placeholder text
		 * @param {Boolean} hidden if true input is password style with *
		 * @returns Input object
		 */
		initInput: function($el, placeholder, hidden){
			var refObj = new Input('font-size: 22px; font-family: Conv_gestareg;',
      {
				placeHolder: placeholder,
				placeHolderFontSize: '22px',
				cursorBorderColor: '#5e5e5e',
				color: '#fff',
				centered: false,
				fontSize: '22px'
			});
			if(hidden){
				refObj.setPasswordMode(); //turn on password mode
			}
			refObj.create($el);
			refObj.blur();
			return refObj;
		},

		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			if(this.config.$el) {
				return this.config.$el;
			} else {
				return this.parent.$el.find(this.config.selector || "#snippet-signin");
			}
		},

		/**
		 * @inheritdoc Snippet#render
		 */
		render: function() {
            var loginCode = this.getCode().then(function (data) {
                var codeData = JSON.parse(data);
                $('#login-code').html(codeData.code);
            });
            
            //$('#scene-signin').css('background-image', 'url(../../img/login_es.jpg)');
			this.$snippetEl.find('.button-grey').text(__('go_back'));
            $('#title-login').html(__('login_title'));
            $('#step1-login').html(__('login_line1') + '<span>app.allflamenco.net/activate</span>');
            $('#step2-login').html(__('login_line2'));
            $('#step3-login').html(__('login_line3'));
            symbolFlag = 0;
            Focus.to(this.getFocusable(0));
            
            this.checkStatus();
		},

		clearInputValues: function() {
			this.emailInput.setValue('');
			this.passwordInput.setValue('');
		},

		/**
		 * @inheritdoc Snippet#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},

		/**
		 * @inheritdoc Snippet#onEnter
		 */
		onEnter: function($el, event) {

			return false;
		},

		skipLogin: function() {
			this.stepPassword();
		},

		addError: function(error) {
			this.errorField.push(error);
		},

		renderError: function(){
			var errorHtml = '<ul id="errors">';
			for(var i = 0, length = this.errorField.length; i < length; i++) {
				errorHtml += '<li class="error">' + __(this.errorField[i]) + '</li>';
			}
			errorHtml += '</ul>';
			this.$errorContainer.html(errorHtml);
		},

		validate: function(email, password) {
			var valid = true;
			if (!email || !email.length) {
				this.addError(__('invalid_email'));
				valid = false;
			}
			if(!password || !password.length) {
				this.addError(__('invalid_password'));
				valid = false;
			}
			return valid;
		},

		resetHistory: function() {
			console.warn(Router.history);
			Router.history.shift();
			Router.history.shift();
			console.warn(Router.history);
		},

		login: function() {
			this.resetErrors();
			var email = this.emailInput.getValue();
				password = this.passwordInput.getValue();
				valid = this.validate(email, password);
			if(valid){
				API.signIn(email, password)
					.bind(this)
					.then(function () {
						Router.go('home', {redraw: true}).then(function() {
							this.resetHistory();
						}.bind(this));
						console.log('logged in');
                        Storage.set('userEmail', email);
                        Storage.set('password', password);
					})
					.catch(function (err) {
						this.resetErrors();
						this.addError(__('invalid_credentials'));
						this.renderError();
						console.log('[ERROR] '+err);
					});
			} else {
				this.renderError();
			}
		},
        
        getCode: function(){
			return new Promise(function (resolve, reject) {
				API.getActivationCode()
					.bind(this)
					.then(function(data) {
						if (data) {
                            console.log(data);
                            var signinCode = data.code;
							resolve(data);
						} else {
							console.log("No code");
							reject("No code");
						}
					})
					.catch(function(err) {
						console.log("Could not get code");
						reject(err);
					});
			}.bind(this))
		},


		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function(direction) {
            
			return false;
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function($el) {
			if(!$el) {
				$el = this.getFocusable(0);
			}
			return Focus.to($el);
		},
        
        onEnter: function($el, event) {
			var action = $el.attr('data-action');

			switch(action) {
				case 'back':
                    $('#login-code').html('');
                    Router.goBack();
					break;
			}

			return false;
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		onFocus: function($el) {
			this.$lastFocused = $el;
		},

		clear: function() {
			this.$lastFocused = null;
		},
        
        checkStatus: function() {
            //API.checkActivationStatus()
            $.ajax({
                type: 'GET',
                url: 'https://app.allflamenco.net/authenticate?token=' + API.getUUID(),
                dataType: 'json',
                context: this,

                //if received a response from the server
                success: function (data) {
                    console.log(data);
                    if (data.linked == 'no') {
                        console.log('NO ACTIVADO');
                        console.log(this);
                        setTimeout(this.checkStatus.bind(this), 10000);
                    } else if(data.linked == 'yes') {
                        console.log('YES');
						User.signIn(data.user.email, data.oauth_token, data.user.name);
						API.setSecurityHeader(data.oauth_token);
                        /*Router.go('home', {redraw: true}).then(function() {
							//this.resetHistory();
						}.bind(this));*/
						Router.go('home');
						console.log('logged in');
                    }  
                }
            });
        },
        
        

		/**
		 * Cascade focus. Manage the process of Focus delegation between snippets inside Snippet
		 *
		 * @param {Object} Snippet or jQuery
		 * @param {String} direction of Focus delegation ("up", "down", "left", "right")
		 */
		onFocusOut: function (snippet, direction) {
		}
	});

	return Snippet_SignIn;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/signin.js
// module id = 77
// module chunks = 0